import React from 'react';
import {inject, observer} from 'mobx-react'
import {toJS, observable} from 'mobx';
import moment from "moment";
import _ from 'lodash';
import $ from 'jquery';
import {standardBasinOrder} from '../../libs/config';

@inject('markerStore', 'contentStore')
@observer
class RiverWatch extends React.Component {

  @observable scrollTop = 0;

  componentDidMount(){
    let x = $(window);
    x.scroll(() => {
      this.scrollTop = x.scrollTop();
    })
  }

  getSortedArray = (items) => {
    let sortedArray = [];
    let dangerItems = items.filter(item => item.status === 'DANGER').sort((a, b) => +a.stationIndex < +b.stationIndex ? -1 : 1);
    let warningItems = items.filter(item => item.status === 'WARNING').sort((a, b) => +a.stationIndex < +b.stationIndex ? -1 : 1);
    let bwlItems = [];
    // let ndItems = items.filter(item => item.status === null);
    let groupedBwlItems = _.groupBy(items.filter(item => item.status === 'BELOW WARNING LEVEL').sort((a, b) => standardBasinOrder.indexOf(a.basin) < standardBasinOrder.indexOf(b.basin) ? -1: 1), item => item.basin);
    Object.keys(groupedBwlItems).map(key => {
      let basinStationWithIndex = groupedBwlItems[key].filter(item => !!item.stationIndex).sort((a, b) => +a.stationIndex < +b.stationIndex ? -1 : 1),
          basinStationWithoutIndex = groupedBwlItems[key].filter(item => !item.stationIndex);
      bwlItems = [...bwlItems, ...basinStationWithIndex, ...basinStationWithoutIndex]
    });


    if (dangerItems.length) sortedArray = [...sortedArray, ...dangerItems.filter(b => !!b.stationIndex), ...dangerItems.filter(b => (!b.stationIndex || b.stationIndex === null || b.stationIndex === ''))];
    if (warningItems.length) sortedArray = [...sortedArray, ...warningItems.filter(b => !!b.stationIndex), ...warningItems.filter(b => (!b.statinoIndex || b.stationIndex === null || b.stationIndex === ''))];
    if (bwlItems.length) sortedArray = [...sortedArray, ...bwlItems];
    // if(ndItems.length) sortedArray = [ ...sortedArray, ...ndItems.sort((a,b) => a.stationIndex && a.name < b.name ?-1:1)];

    return sortedArray;
  };

  render() {
    const {markerStore, contentStore: {alerts}} = this.props;
    let riverWatchData = markerStore.river_raw ? this.getSortedArray(markerStore.river_raw.filter(item => item.waterLevel && item.waterLevel !== 'N/A' && !!item.waterLevel.value)) : [];
//console.log(toJS(markerStore.river_raw.find(item => item.id == 5125)))
//console.log(toJS(riverWatchData.find(item => item.id == 5125)))

    return (
      <div style={{margin: '-10px'}}>
        {/*<h1 className="text-center watch"><b>RIVER WATCH</b></h1>*/}
        {/*{((alerts.length === 0 && this.scrollTop >= 150) || (alerts.length >= 0 && this.scrollTop >= 172)) ? <table className="watch_table" style={{position: 'fixed', top: 0, width: '100%', zIndex: 2}}>*/}
          {/*<thead className="watch_table_thead">*/}
          {/*<tr className="watch_table_tr">*/}
            {/*<th className="watch_table_th" width="3%">S.N</th>*/}
            {/*<th className="watch_table_th" width="6%">Basin Name</th>*/}
            {/*<th className="watch_table_th" width="5%">Station Index</th>*/}
            {/*<th className="watch_table_th" width="18%">Station Name</th>*/}
            {/*<th className="watch_table_th" width="8%">District</th>*/}
            {/*<th className="watch_table_th" width="8%">Water Level (m)</th>*/}
            {/*/!*<th className="watch_table_th" width="8%">Approx Flow (m<span className="superscript">3</span>/sec)</th>*!/*/}
            {/*<th className="watch_table_th" width="8%">Warning Level (m)</th>*/}
            {/*<th className="watch_table_th" width="9%">Danger Level (m)</th>*/}
            {/*<th className="watch_table_th" width="8%">Trend</th>*/}
            {/*<th className="watch_table_th" width="20%">Status</th>*/}
            {/*<th className="watch_table_th" width="10%">O & M by</th>*/}
          {/*</tr>*/}
          {/*</thead>*/}
        {/*</table>: null}*/}
        {!!markerStore.river_discharge.length && <div style={{padding: 5, fontSize: 14}}>
          Estimated real time discharge in m3/s: {markerStore.river_discharge.filter(item => !!item.discharge).map(({name, discharge}) => (`[${name}: ${discharge}] `))}  
        </div>}
        <table className="watch_table" style={{width: '100%'}}>
          <caption className="watch_table_caption">Last updated on {markerStore.rainfall_lastUpdateTime} </caption>
          <thead className="watch_table_thead">
          <tr className="watch_table_tr">
            <th className="watch_table_th" width="3%">S.N</th>
            <th className="watch_table_th" width="6%">Basin Name</th>
            <th className="watch_table_th" width="5%">Station Index</th>
            <th className="watch_table_th" width="18%">Station Name</th>
            <th className="watch_table_th" width="8%">District</th>
            <th className="watch_table_th" width="8%">Water Level (m)</th>
            {/*<th className="watch_table_th" width="8%">Approx Flow (m<span className="superscript">3</span>/sec)</th>*/}
            <th className="watch_table_th" width="8%">Warning Level (m)</th>
            <th className="watch_table_th" width="9%">Danger Level (m)</th>
            <th className="watch_table_th" width="8%">Trend</th>
            <th className="watch_table_th" width="20%">Status</th>
            <th className="watch_table_th" width="10%">O & M by</th>
          </tr>
          </thead>
          <tbody className="watch_table_tbody">
          {
            riverWatchData.map((item, index) => (
              <tr key={item.id}
                  className={item.status ? `${item.status.split(' ')[0]}_RIVER watch_table_tr` : 'watch_table_tr'}>
                <td className="space watch_table_td" width="3%">{index + 1}</td>
                <td className="watch_table_td" width="6%">{item.basin}</td>
                <td className="watch_table_td" width="5%">{item.stationIndex}</td>
                <td width="18%"
                  className="watch_table_td">{item.name}<br/><span>{item.waterLevel && moment(item.waterLevel.datetime).format('llll')}</span>
                </td>
                <td className="watch_table_td" width="8%">{item.district}</td>
                <td width="8%"
                  className="watch_table_td">{item.waterLevel && parseFloat(item.waterLevel.value) ? Math.round(item.waterLevel.value * 100) / 100 : 'N/A'}</td>
                {/*<td className="watch_table_td" width="8%">-</td>*/}
                <td className="watch_table_td" width="8%">{item.warning_level}</td>
                <td className="watch_table_td" width="8%">{item.danger_level}</td>
                <td className="watch_table_td" width="8%">{item.steady}</td>
                <td className="watch_table_td" width="20%">
                  {item.status}
                  {/*{(item.status === 'DANGER' && moment(item.waterLevel.datetime).format('YYYY-MM-DD')=== moment().format('YYYY-MM-DD')) || (item.status === 'WARNING' && moment(item.waterLevel.datetime).format('YYYY-MM-DD')=== moment().format('YYYY-MM-DD')) ? <Alarm/> : null}*/}
                </td>
                <td className="watch_table_td" width="10%">{item.onm}</td>
              </tr>
            ))
          }
          </tbody>
        </table>
      </div>
    );
  }
}

export default RiverWatch;





// WEBPACK FOOTER //
// ./src/components/Watch/RiverWatch.js